import React, { useRef, useEffect } from 'react';
import './Header.scss';
import { Tween, SplitChars, SplitWords } from 'react-gsap';

function Header() {
    const ref = useRef(null);

    return (
        <section id='home'>
            <div className="wrapper" ref={ref}>
                <div className="header__grid">
                    <div className="row1">
                        <div>
                            <Tween from={{ y: '100px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={1}>
                                <SplitChars wrapper={<span style={{ display: 'inline-block' }} />}>
                                    Computer
                                </SplitChars>
                            </Tween>
                        </div>
                        <div>
                            <Tween from={{ y: '100px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={1}>
                                <SplitChars wrapper={<span style={{ display: 'inline-block' }} />}>
                                    Engineer
                                </SplitChars>
                            </Tween>
                        </div>
                    </div>
                    <div className="row2">
                        {/* <Tween from={{ y: '50px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={4} stagger={0.9} delay={3}>

                            <div className="marquee">
                                <span>
                                    Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio Welcome To my Portfolio
                                </span>
                                <spanspan>
                            </div>
                        </Tween> */}
                    </div>

                    
                    <div className="row3">

                        <div className="left__text">
                            <span>
                                <Tween from={{ y: '50px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={3}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24">
                                        <path d="M12 20l-8-8h16z" />
                                    </svg>
                                </Tween>

                            </span>
                        </div>
                        <div className="middle__text">
                            <div>
                                <Tween from={{ y: '100px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={2}>
                                    <SplitWords
                                        wrapper={<div style={{ display: 'inline-block' }} />}
                                        delimiter=" "
                                    >
                                        Engineering Student by day Creative dev by night.
                                    </SplitWords>
                                </Tween>
                            </div>
                        </div>
                        <div className="right__text">
                            <div>
                                <Tween from={{ y: '100px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={1.5}>
                                    <SplitChars wrapper={<span style={{ display: 'inline-block' }} />}>
                                        CREATIVE
                                    </SplitChars>
                                </Tween>
                            </div>
                            <div>
                                <Tween from={{ y: '100px', opacity: 0 }} to={{ y: '0px', opacity: 1 }} ease="Expo.easeOut" duration={2} stagger={0.09} delay={1.5}>
                                    <SplitChars wrapper={<span style={{ display: 'inline-block' }} />}>
                                        DEVELOPER
                                    </SplitChars>
                                </Tween>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Header;